import * as actionTypes from "../actions";

const initialState = {
    step: actionTypes.SEATS_STEP,
    orderStep: actionTypes.ORDER_MENU_STEP
};

const uiReducer = (state = initialState, action) => {
    switch (action.type) {

        // SET STEP
        case actionTypes.SET_STEP:
            return {
                ...state,
                step: action.step
            };

        // SET ORDER STEP
        case actionTypes.SET_ORDER_STEP:
            return {
                ...state,
                orderStep: action.step
            };

        default:
            return state;
    }
};

export default uiReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/ui.js